export const TYPE_MESSAGE_GROUP = 'messageGroup'
export const TYPE_USER = 'user'
export const TYPE_CUSTOMER_PRODUCT = 'customerProduct'
